let routes = [
  {
    path:      '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children:  [
      {
        path:      '/404',
        name:      'pageError404',
        component: () => import('@/views/pages/Error404.vue'),
      },
      {
        path:      '*',
        component: () => import('@/views/pages/Error404.vue'),
      },
    ],
  },
];

export default routes;
